<template>
  <div>
    <FilePopup
      v-if="isFilePriview"
      v-bind:filedata="filePriviewData"
      @closePopup="closePopup"
    ></FilePopup>

    <!-- wrap -->
    <div class="sm_star" v-if="!isFilePriview">
      <!-- header -->
      <div class="sm_header">
        <h1>{{ $t("S10051") }}</h1>
        <button class="back_btn" @click="$router.go(-1)">
          <span>back btn</span>
        </button>
        <button
          class="upload_btn"
          @click="askForRegister"
          :disabled="isDisabled"
        >
          <span>{{ $t("S20095") }}</span>
        </button>
      </div>
      <!-- //header -->

      <!-- content -->
      <div class="sm_wrap bg-white">
        <div class="write_wrap">
          <div class="tag_form">
            <!-- 1 Title -->
            <div class="mgt-16 pdl-15 pdr-15 bg-white">
              <div
                class="w-full mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon"
                :class="form.subjectValid ? 'mdc-text-field--invalid' : ''"
                id="subjectEl"
              >
                <!-- <i
                  class="material-icons mdc-text-field__icon mdc-icon-custom"
                  :class="{ 'valid-error': form.subjectValid }"
                >
                  {{ form.validIcon }}
                </i> -->
                <input
                  type="text"
                  class="mdc-text-field__input custom-filled-input"
                  @input="handleSubject"
                  :value="form.contents.subject"
                  maxlength="100"
                  ref="subject"
                  id="subject"
                  name="subject"
                  v-validate="'required'"
                  @keyup="validateSubject"
                  @blur="validateSubject"
                />
                <div class="mdc-notched-outline">
                  <div class="mdc-notched-outline__leading"></div>
                  <div class="mdc-notched-outline__notch">
                    <label
                      for="tf-outlined"
                      class="mdc-floating-label"
                      :class="{ 'valid-error': form.subjectValid }"
                      >{{ $t("S20124") }}</label
                    >
                  </div>
                  <div class="mdc-notched-outline__trailing"></div>
                </div>
              </div>
              <!-- <div
                class="t-helper t-color-textfieldError mgl-7 mgr-7 pdt-2 min-h-23"
              >
                <span
                  class="t-color-helper"
                  :class="{ 'valid-error': form.subjectValid }"
                  v-show="form.subjectValid"
                >
                  {{ $t("S10080") }}
                </span>
              </div> -->
            </div>

            <!-- 2 CATEGORY -->
            <div
              v-show="boardInfoCategory"
              class="mgt-16 pdl-15 pdr-15 bg-white"
            >
              <div
                class="mdc-select mdc-select--outlined w-full mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon categoryEl"
                :class="form.categoryValid ? 'mdc-text-field--invalid' : ''"
                id="categoryEl"
              >
                <i
                  class="mdc-select__dropdown-icon select-icon-custom"
                  :class="{ 'valid-error': form.categoryValid }"
                ></i>
                <!-- <i
                  class="material-icons mdc-text-field__icon mdc-icon-custom"
                  :class="{ 'valid-error': form.subjectValid }"
                >
                  {{ form.validIcon }}
                </i> -->
                <select
                  class="mdc-select__native-control custom-filled-input"
                  :class="{ 'valid-error': form.categoryValid }"
                  @change="handleCategory"
                  ref="category"
                  id="category"
                  name="category"
                  v-validate="'required'"
                >
                  <option value="" disabled selected hidden style="color: red">
                    {{ $t("S20087") }}
                  </option>
                  <option
                    v-for="(category, index) in boardInfoCategory"
                    :key="index"
                    :value="category.id"
                  >
                    {{ category.name }}
                  </option>
                </select>
                <div class="mdc-notched-outline">
                  <div class="mdc-notched-outline__leading"></div>
                  <div class="mdc-notched-outline__notch">
                    <!-- <label
                      for="tf-outlined"
                      class="mdc-floating-label"
                      :class="{ 'valid-error': form.subjectValid }"
                      >카테고리</label
                    > -->
                  </div>
                  <div class="mdc-notched-outline__trailing"></div>
                </div>
              </div>
              <!-- <div
                class="t-helper t-color-textfieldError mgl-7 mgr-7 pdt-2 min-h-23"
              >
                <span
                  class="t-color-helper"
                  :class="{ 'valid-error': form.subjectValid }"
                  v-show="form.subjectValid"
                >
                  {{ $t("S10080") }}
                </span>
              </div> -->
            </div>

            <!-- 3 COUNTRY -->
            <div class="mgt-16 pdl-15 pdr-15 bg-white">
              <div
                class="w-full mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon"
                :class="
                  form.detailValid.country ? 'mdc-text-field--invalid' : ''
                "
                id="countryEl"
              >
                <!-- <i
                  class="material-icons mdc-text-field__icon mdc-icon-custom"
                  :class="{ 'valid-error': form.detailValid.country }"
                >
                  {{ form.validIcon }}
                </i> -->
                <input
                  type="text"
                  class="mdc-text-field__input custom-filled-input"
                  @input="(e) => handleDetail(e, 'country')"
                  :value="form.detail.country"
                  maxlength="50"
                  ref="country"
                  id="country"
                  name="country"
                  v-validate="'required'"
                  @keyup="validateDetail('country')"
                  @blur="validateDetail('country')"
                  disabled
                />
                <div class="mdc-notched-outline">
                  <div class="mdc-notched-outline__leading"></div>
                  <div class="mdc-notched-outline__notch">
                    <!-- <label
                      for="tf-outlined"
                      class="mdc-floating-label"
                      :class="{ 'valid-error': form.detailValid.country }"
                      >{{ $t("S20088") }}</label
                    > -->
                  </div>
                  <div class="mdc-notched-outline__trailing"></div>
                </div>
              </div>
              <!-- <div
                class="t-helper t-color-textfieldError mgl-7 mgr-7 pdt-2 min-h-23"
              >
                <span
                  class="t-color-helper"
                  :class="{ 'valid-error': form.subjectValid }"
                  v-show="form.subjectValid"
                >
                  {{ $t("S10080") }}
                </span>
              </div> -->
            </div>

            <!-- 4 competition -->
            <div class="mgt-16 pdl-15 pdr-15 bg-white">
              <div
                class="mdc-select mdc-select--outlined w-full"
                :class="
                  form.detailValid.competition ? 'mdc-select--invalid' : ''
                "
                id="competitionEl"
              >
                <i class="mdc-select__dropdown-icon select-icon-custom"></i>
                <select
                  class="mdc-select__native-control"
                  @change="(e) => handleCompetion(e)"
                >
                  <option value=""></option>
                  <option
                    v-for="(item, i) in competitionList"
                    :key="i"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
                <div class="mdc-notched-outline">
                  <div class="mdc-notched-outline__leading"></div>
                  <div class="mdc-notched-outline__notch">
                    <label
                      v-if="
                        !isFormCompetition &&
                        !(
                          form.detail.competition &&
                          form.detail.competition.length > 0
                        )
                      "
                      class="mdc-floating-label"
                      :class="{ 'valid-error': form.detailValid.competition }"
                      >{{ $t("S20089") }}
                    </label>
                  </div>
                  <div class="mdc-notched-outline__trailing"></div>
                </div>
              </div>
            </div>

            <!-- Competition - Others -->
            <div class="mgt-16 pdl-15 pdr-15 bg-white" v-if="isFormCompetition">
              <div
                class="w-full mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon"
                :class="
                  form.detailValid.competitionOther
                    ? 'mdc-text-field--invalid'
                    : ''
                "
                id="competitionOtherEl"
              >
                <input
                  type="text"
                  class="mdc-text-field__input custom-filled-input"
                  @input="(e) => handleDetail(e, 'competitionOther')"
                  :value="form.detail.competitionOther"
                  maxlength="50"
                  ref="competitionOther"
                  id="competitionOther"
                  name="competitionOther"
                  v-validate="'required'"
                  @keyup="validateDetail('competitionOther')"
                  @blur="validateDetail('competitionOther')"
                />
                <div class="mdc-notched-outline">
                  <div class="mdc-notched-outline__leading"></div>
                  <div class="mdc-notched-outline__notch">
                    <label
                      for="tf-outlined"
                      class="mdc-floating-label"
                      :class="{
                        'valid-error': form.detailValid.competitionOther,
                      }"
                      >{{ $t("S20126") }}</label
                    >
                  </div>
                  <div class="mdc-notched-outline__trailing"></div>
                </div>
              </div>
            </div>

            <div class="divider mgt-16" />

            <!-- 5 retailer -->
            <div class="mgt-16 pdl-15 pdr-15 bg-white">
              <div
                class="w-full mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon"
                :class="
                  form.detailValid.retailer ? 'mdc-text-field--invalid' : ''
                "
                id="retailerEl"
              >
                <!-- <i
                  class="material-icons mdc-text-field__icon mdc-icon-custom"
                  :class="{ 'valid-error': form.detailValid.retailer }"
                >
                  {{ form.validIcon }}
                </i> -->
                <input
                  type="text"
                  class="mdc-text-field__input custom-filled-input"
                  @input="(e) => handleDetail(e, 'retailer')"
                  :value="form.detail.retailer"
                  maxlength="50"
                  ref="retailer"
                  id="retailer"
                  name="retailer"
                  v-validate="'required'"
                  @keyup="validateDetail('retailer')"
                  @blur="validateDetail('retailer')"
                />
                <div class="mdc-notched-outline">
                  <div class="mdc-notched-outline__leading"></div>
                  <div class="mdc-notched-outline__notch">
                    <label
                      for="tf-outlined"
                      class="mdc-floating-label"
                      :class="{ 'valid-error': form.detailValid.retailer }"
                      >{{ $t("S20090") }}</label
                    >
                  </div>
                  <div class="mdc-notched-outline__trailing"></div>
                </div>
              </div>
              <!-- <div
                class="t-helper t-color-textfieldError mgl-7 mgr-7 pdt-2 min-h-23"
              >
                <span
                  class="t-color-helper"
                  :class="{ 'valid-error': form.subjectValid }"
                  v-show="form.subjectValid"
                >
                  {{ $t("S10080") }}
                </span>
              </div> -->
            </div>
          </div>

          <!-- tag -->
          <!-- <div class="write_tag">
            <div class="tag_form">
              <button type="button" class="tag_btn">{{ $t("S10081") }}</button>
              <span
                class="mr-10 txt"
                v-for="(tag, i) in form.tags"
                :key="i"
                style="
                  background: #f4f5f6;
                  padding: 2px 3px;
                  font-size: 12px;
                  color: #313d4b;
                "
              >
                {{ tag.name }}
                <span @click="removeTag(i)" class="p-5 cursor-pointer">x</span>
              </span>
              <input
                class="txt no-border"
                :placeholder="form.tags.length == 0 ? $t('S10081') : ''"
                @keyup="searchTags($event.target.value, $event)"
                id="tagInput"
              />
            </div>
            <ul v-if="tags && tags.length" class="tag-ul">
              <li
                v-for="tag in tags"
                :key="tag.id"
                @click="addTag(tag)"
                class="cursor-pointer"
              >
                {{ tag.name }}
              </li>
            </ul>
            <p class="t-helper mgl-7 mgr-7 pdt-2 min-h-23 t-color-gray0">
              {{ $t("S10056") }}
            </p>
          </div> -->

          <!-- write -->
          <div
            class="write_form"
            :class="{ write_form__attachment: form.contents.images.length > 0 }"
          >
            <textarea
              ref="textarea1"
              :placeholder="[
                $t('S10057') +
                  `\n` +
                  $t('S10073') +
                  `\n` +
                  $t('S10074') +
                  `\n` +
                  $t('S10075') +
                  `\n` +
                  $t('S10077') +
                  `\n` +
                  $t('S10078'),
              ]"
              v-model="form.contents.body"
            ></textarea>
            <!-- <VueEditor
              v-model="form.contents.body"
              :editor-toolbar="customToolbar"
              @keyup="validateBody()"
              @blur="validateBody()"
            /> -->
            <div class="editor-label">{{ $t("S20091") }}</div>
            <div class="editor-label">{{ $t("S20092") }}</div>
            <div
              v-show="bodyValid || attachmentValid"
              class="editor-label label-warning"
            >
              {{ $t("S20094") }}
            </div>

            <div
              class="attachment-wrapper"
              style="white-space: nowrap; overflow-x: auto; padding-top: 15px"
            >
              <div
                v-for="(item, i) in attachmentList"
                :key="i"
                class="post-img position-relative mgr-20"
              >
                <div
                  v-if="item.contentType.indexOf('video') === -1"
                  class="post-img-wrapper"
                >
                  <img
                    @click="priviewFiel(item)"
                    :src="item.resourceUri"
                    :alt="item.originalName"
                  />
                  <span
                    @click="deleteAttachment(i, 'IMAGE')"
                    class="remove-img remove-image-new position-absolute t-color-white"
                    ><img
                      src="/images/close.svg"
                      style="width: 20px; height: 20px"
                  /></span>
                </div>

                <div
                  class="post-video position-relative mgr-20"
                  v-else
                  style="width: 100px; position: relative"
                >
                  <video-player
                    class="video-player-box"
                    :options="{
                      muted: true,
                      language: 'en',
                      playbackRates: [0.7, 1.0, 1.5, 2.0],
                      sources: [
                        {
                          type: item.contentType,
                          src: item.resourceUri,
                        },
                      ],
                      height: 100,
                      width: 100,
                    }"
                    :playsinline="true"
                  />
                  <div
                    @click="priviewFiel(item)"
                    style="
                      position: absolute;
                      background-color: transparent;
                      width: 100px;
                      height: 100px;
                      margin-top: -88px;
                      z-index: 999;
                    "
                  ></div>
                  <span
                    @click="deleteAttachment(i, 'VIDEO')"
                    class="remove-img remove-image-new position-absolute t-color-white"
                    ><img src="/images/close.svg" style="width: 20px"
                  /></span>
                </div>
              </div>
            </div>
          </div>
          <!-- //write -->

          <div class="comment_box write">
            <div class="comment_area">
              <input
                type="file"
                id="commentFileUpload"
                :accept="allowExt()"
                @change="uploadFile"
                class="d-none"
              />
              <span
                class="material-icons radar-icons picture_btn"
                :class="{
                  'label-warning': attachmentValid,
                }"
                @click="openFileUpload(true)"
              >
                photo_library
              </span>
              <!-- <span
                class="material-icons radar-icons picture_btn"
                @click="openFileUpload(false)"
              >
                videocam
              </span> -->
            </div>
          </div>
        </div>
      </div>
      <!-- //content -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import { MDCRipple } from "@material/ripple";
import { MDCSelect } from "@material/select";
import { MDCTextField } from "@material/textfield";
import radarApi from "@/api/radarApi.js";
import FilePopup from "./FilePopup";
// require styles
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import _ from "lodash";

export default {
  components: {
    videoPlayer,
    FilePopup,
  },
  data() {
    return {
      attachmentValid: false,
      bodyValid: false,
      attachmentList: [],
      boardInfoCategory: null,
      form: {
        status: null,
        boardType: null,
        notifyType: null,
        subjectTextField: "",
        subjectValid: false,
        contentValid: false,
        contents: {
          type: null,
          subject: null,
          body: null,
          linkName: null,
          linkUrl: null,
          images: [],
          video: {
            chunkCount: 0,
            contentType: null,
            duration: 0,
            height: 0,
            id: null,
            name: null,
            originalName: null,
            resourceUri: null,
            size: 0,
            subFileResourceUri: [],
            width: 0,
          },
        },
        fixed: false,
        tags: [],
        detail: {
          competition: null,
          competitionOther: null,
          country: null,
          retailer: null,
        },
        category: {
          value: null,
          text: null,
        },
        detailValid: {
          competition: false,
          competitionOther: false,
          country: false,
          retailer: false,
        },
        categoryValid: false,
        detailTextField: {
          competition: "",
          country: "",
          translate: "",
        },
        categoryTextField: "",
      },
      tags: [],
      // check if upload is set ti image or video
      uploadTypeImg: true,
      isDisabled: false,
      filePriviewData: [],
      isFilePriview: false,
      boardId: null,
      boardData: null,
      identifier: null,

      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ["small", false, "large", "huge"] }][
          ("bold", "italic", "underline", "strike")
        ],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ color: [] }, { background: [] }],
        // [{ script: "sub" }, { script: "super" }],
        // ["link", "image", "video", "formula"],
        // [{ direction: "rtl" }],
        // ["clean"],
      ],

      // competition list
      competitionList: [
        "LG",
        "SONY",
        "TCL",
        "Hisense",
        "PHILIPS",
        "Sonos",
        "Bose",
        this.$t("S20125"),
      ],
      isFormCompetition: false,
    };
  },

  beforeCreate() {
    this.boardId = this.$route.query.bId;
  },

  beforeMount() {
    this.boardId = this.$route.query.bId;
    this.setDetail();
    this.findBoardData();

    radarApi
      .fetchMember()
      .then((response) => {
        this.mamberData = response.data.data;
      })
      .catch((err) => {
        $state.error();
      });
  },

  mounted() {
    this.updateMDCTextField();
    const buttonRipple = [].map.call(
      document.querySelectorAll(".mdc-button"),
      function (el) {
        let button = new MDCRipple.attachTo(el);
        return button;
      }
    );
    const selectDiv = document.querySelector(".mdc-select");
    this.categoryTextField = new MDCSelect(selectDiv);
    this.getMemberData();
  },

  updated() {
    this.updateMDCTextField();
  },

  watch: {
    "form.contents.body": function (val) {
      if (!val || val.length === 0) {
        this.bodyValid = true;
      } else {
        this.bodyValid = false;
      }
    },

    "form.category": function (val) {
      if (val.text && val.text.length > 0 && val.value) {
        this.form.categoryValid = false;
      } else {
        this.form.categoryValid = true;
      }
    },

    attachmentList: function (val) {
      if (val.length === 0) {
        this.attachmentValid = true;
      } else {
        this.attachmentValid = false;
      }
    },
  },

  methods: {
    async getMemberData() {
      try {
        const memberResult = await radarApi.fetchMember();
        this.form.detail.country = memberResult.data.data.responsibilityName;
      } catch (error) {
        console.log("GET MEMBER RESULT ERROR : ", error);
      }
    },

    async findBoardData() {
      try {
        const authResult = await radarApi.getRadarBoardId();
        this.boardInfoCategory =
          authResult.data.data.boardCategory.childCategory;
        this.identifier = authResult.data.data.identifier;
      } catch (error) {
        console.log("AUTH RESULT ERROR : ", error);
      }

      radarApi
        .boardAuth(this.identifier)
        .then((response) => {
          this.boardData = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    priviewFiel(file) {
      this.filePriviewData = file;
      this.isFilePriview = true;
    },
    closePopup() {
      this.filePriviewData = Array();
      this.isFilePriview = false;
    },

    deleteAttachment(i, type) {
      this.attachmentList.splice(i, 1);
      if (type === "IMAGE") {
        this.form.contents.images.splice(i, 1);
      } else {
        this.resetVideo();
      }
    },
    resetVideo() {
      this.form.contents.video = {
        chunkCount: 0,
        contentType: null,
        duration: 0,
        height: 0,
        id: null,
        name: null,
        originalName: null,
        resourceUri: null,
        size: 0,
        subFileResourceUri: [],
        width: 0,
      };
    },
    uploadFile(evt) {
      let filePath = evt.target.files[0].name;
      // Allowing file type
      let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.mov|\.mp4)$/i;
      const isImg = /(\.jpg|\.jpeg|\.png|\.gif)$/i.exec(filePath);

      if (!allowedExtensions.exec(filePath)) {
        this.$snackOpen({
          contents: this.$t("S10057"),
          btnDisplayYN: false,
        }).then(() => {});
        return false;
      }
      if (!evt.target.files[0]) return;

      // validate video and/or audio
      //if (!this.videoAudioSelected()) return;

      // check if image selected then count number of image selected
      if (!this.invalidCountImg(isImg)) return;

      // check if user try to add more than 1 video
      if (!this.invalidVideoCount(isImg)) return;

      this.$showLoading();
      radarApi
        .upload(evt.target.files[0])
        .then((response) => {
          // check if user uploaded an image
          this.attachmentList = [...this.attachmentList, response.data.data[0]];
          if (response.data.data[0].contentType.indexOf("video") === -1) {
            this.form.contents.images.push({
              ...response.data.data[0],
              attachmentListId: this.attachmentList.length - 1,
            });
          } else {
            this.form.contents.video = {
              ...response.data.data[0],
              attachmentListId: this.attachmentList.length - 1,
            };
          }
          this.$hideLoading();
        })
        .catch((err) => {
          this.$hideLoading();
          this.$error({ content: err.errMsg }).then(() => {});
        });
      evt.target.value = "";
    },
    videoAudioSelected() {
      if (
        (this.uploadTypeImg &&
          this.form.contents.video &&
          this.form.contents.video.resourceUri) ||
        (!this.uploadTypeImg && this.form.contents.images.length)
      ) {
        this.$alert({
          // title: this.$t('72'),
          content: this.$t("1473"),
          accept: this.$t("1476"),
        });
        return false;
      }
      return true;
    },
    invalidCountImg(isImg) {
      if (isImg && this.form.contents.images.length >= 5) {
        this.$snackOpen({
          contents: this.$t("S20093"),
          btnDisplayYN: false,
        }).then(() => {});
        return false;
      }
      return true;
    },
    invalidVideoCount(isImg) {
      if (
        !isImg &&
        this.form.contents.video &&
        this.form.contents.video.resourceUri
      ) {
        this.$snackOpen({
          contents: this.$t("S20093"),
          btnDisplayYN: false,
        }).then(() => {});
        return false;
      }
      return true;
    },
    openFileUpload(allowImg) {
      this.uploadTypeImg = allowImg;
      setTimeout(() => {
        document.getElementById("commentFileUpload").click();
      }, 0);
    },
    allowExt() {
      return "image/jpeg, image/png, video/mp4";
    },
    register() {
      if (!this.boardData) {
        this.findBoardData();
      }

      // others인 경우
      if (this.isFormCompetition) {
        this.form.detail.competition = this.form.detail.competitionOther;
      }

      if (this.boardData.userBbsToDayAuth) {
        if (this.form.id) {
          this.$showLoading();
          radarApi
            .updatePost(this.form.id, this.form, this.identifier)
            .then((response) => {
              this.$hideLoading();
              this.isDisabled = true;
              this.$router.push("/radar/" + response.data.data.id);
            })
            .catch((err) => {
              this.$error({ content: err.errMsg }).then(() => {});
            });
        } else {
          this.$alert({
            content: this.$t("S10052"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
            accept: this.$t("S10053"),
          })
            .then(() => {
              this.$showLoading();
              radarApi
                .register(this.form, this.identifier)
                .then((response) => {
                  this.$hideLoading();
                  this.isDisabled = true;
                  this.$router.push("/radar/" + response.data.data.id);
                })
                .catch((err) => {
                  this.$error({ content: err.errMsg }).then(() => {});
                });
            })
            .catch(() => {});
        }
      } else {
        this.$alert({
          content: this.$t("3064"),
          accept: this.$t("3065"),
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    setDetail() {
      if (!this.$route.params.postId && !this.$route.params.identifier) return;

      this.$showLoading();
      radarApi
        .socialDetails({
          identifier: this.identifier
            ? this.identifier
            : this.$route.params.identifier,
          postId: this.$route.params.postId,
        })
        .then((response) => {
          // Object.assign(this.form, response.data.data);
          for (let item in response.data.data) {
            if (item === "detail") {
              this.form[item].competition =
                response.data.data[item].competition;
              this.form[item].id = response.data.data[item].id;
              this.form[item].retailer = response.data.data[item].retailer;
            } else if (item === "category") {
              this.form[item] = response.data.data.boardCategory;
            } else {
              this.form[item] = response.data.data[item];
            }
          }
          this.$hideLoading();
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },

    validateSubject() {
      if (
        this.form.contents.subject &&
        this.form.contents.subject.length === 0
      ) {
        this.form.subjectValid = true;
        this.form.validIcon = "warning";
        return;
      } else {
        this.form.subjectValid = false;
        this.form.validIcon = "";
      }
    },

    validateCategory() {
      if (
        this.form.category.text === null ||
        this.form.category.text.length === 0
      ) {
        this.form.categoryValid = true;
      } else {
        this.form.categoryValid = false;
      }
    },

    validateDetail(type) {
      if (this.form.detail[type] && this.form.detail[type].length === 0) {
        this.form.detailValid[type] = true;
        return;
      } else {
        this.form.detailValid[type] = false;
      }
    },

    validateBody() {
      console.log("VALIDATE BODY");
    },

    askForRegister() {
      // 필수 입력 사항 검증
      if (
        (this.form.contents.subject === null &&
          this.form.contents.body === null) ||
        this.form.contents.subject === null ||
        this.form.contents.subject.length === 0 ||
        !this.form.detail.country ||
        this.form.detail.country.length === 0 ||
        !this.form.detail.competition ||
        this.form.detail.competition.length === 0 ||
        !this.form.detail.retailer ||
        this.form.detail.retailer.length === 0 ||
        !this.form.contents.body ||
        this.form.contents.body.length < 50 ||
        this.form.category.text === null ||
        this.form.category.text.length === 0 ||
        this.attachmentList.length === 0 ||
        (this.isFormCompetition &&
          (!this.form.detail.competitionOther ||
            (this.form.detail.competitionOther &&
              this.form.detail.competitionOther.length === 0)))
      ) {
        // 각 조건에 따라 valid 값을 설정합니다.
        if (
          this.form.contents.subject === null ||
          this.form.contents.subject.length === 0
        ) {
          this.form.subjectValid = true;
        } else {
          this.form.subjectValid = false;
        }

        if (
          this.form.category.text === null ||
          this.form.category.text.length === 0
        ) {
          this.form.categoryValid = true;
        } else {
          this.form.categoryValid = false;
        }

        if (
          !this.form.detail.country ||
          this.form.detail.country.length === 0
        ) {
          this.form.detailValid.country = true;
        }

        if (
          !this.form.detail.competition ||
          this.form.detail.competition.length === 0
        ) {
          this.form.detailValid.competition = true;
        }

        if (
          this.isFormCompetition &&
          (!this.form.detail.competitionOther ||
            (this.form.detail.competitionOther &&
              this.form.detail.competitionOther.length === 0))
        ) {
          this.form.detailValid.competitionOther = true;
        }

        if (
          !this.form.detail.retailer ||
          this.form.detail.retailer.length === 0
        ) {
          this.form.detailValid.retailer = true;
        }

        if (!this.form.contents.body || this.form.contents.body.length === 0) {
          this.bodyValid = true;
        } else {
          this.bodyValid = false;
        }

        if (this.attachmentList.length === 0) {
          this.attachmentValid = true;
        } else {
          this.attachmentValid = false;
        }

        if (this.form.contents.body && this.form.contents.body.length < 50) {
          this.$alert({
            content: this.$t("S10042"),
            accept: this.$t("S10053"),
          });
        }

        // 어떤 조건도 충족되지 않으면 실행되지 않습니다.
        this.isDisabled = false;
        return;
      }

      // 모든 검증을 통과한 경우
      this.form.validIcon = "";
      this.isDisabled = true;
      this.register();
    },
    searchTags: _.throttle(function (str, event) {
      if (event.key === "Enter") {
        radarApi
          .createTags({ name: str.trim() })
          .then((response1) => {
            let rs = response1.data.data;
            this.addTag(rs);
          })
          .catch((err) => {
            this.$error({ content: err.errMsg }).then(() => {});
          });
      }

      if (this.form.tags.length == 0) {
        radarApi
          .searchTags(str.trim())
          .then((response) => {
            this.tags = response.data.data;
            if (str.indexOf(" ") >= 0 && this.tags.length < 1) {
              radarApi
                .createTags({ name: str.trim() })
                .then((response1) => {
                  let rs = response1.data.data;

                  if (rs.id) {
                    this.searchTags(str);
                  }
                })
                .catch((err) => {
                  this.$error({ content: err.errMsg }).then(() => {});
                });
            }
          })
          .catch((err) => {
            this.$error({ content: err.errMsg }).then(() => {});
          });
      } else {
        if (str.indexOf(" ") >= 0) {
          radarApi
            .createTags({ name: str.trim() })
            .then((response1) => {
              let rs = response1.data.data;
              if (rs.id) {
                radarApi
                  .searchTags(str.trim())
                  .then((response) => {
                    this.tags = response.data.data;
                  })
                  .catch((err) => {
                    this.$error({ content: err.errMsg }).then(() => {});
                  });
              }
            })
            .catch((err) => {
              this.$error({ content: err.errMsg }).then(() => {});
            });
        }
      }
    }, 2000),
    createTags(str) {
      alert(str);
    },
    addTag(tag) {
      this.form.tags.push(tag);
      this.tags = [];
      document.getElementById("tagInput").value = null;
    },
    removeTag(index) {
      this.form.tags.splice(index, 1);
    },
    handleSubject(e) {
      this.form.contents.subject = e.target.value;
    },
    handleCategory(e, type) {
      const selectedCategory = this.boardInfoCategory.find(
        (category) => category.id === Number(e.target.value)
      );
      this.form.category = {
        value: selectedCategory.id,
        text: selectedCategory.name,
      };
    },
    handleDetail(e, type) {
      this.form.detail[type] = e.target.value;
    },

    handleCompetion(e) {
      if (e.target.value === "Others") {
        this.isFormCompetition = true;
      } else {
        this.isFormCompetition = false;
      }

      this.validateDetail("competition");
      this.handleDetail(e, "competition");
    },

    updateMDCTextField() {
      const mdcTextFieldList = document.querySelectorAll(".mdc-text-field");
      mdcTextFieldList.forEach((mdc, i) => {
        switch (i) {
          case 0:
            this.form.subjectTextField = new MDCTextField(mdc);
            break;
          case 1:
            break;
          case 2:
            this.form.detailTextField.country = new MDCTextField(mdc);
            break;
          case 3:
            this.form.detailTextField.competition = new MDCTextField(mdc);
            break;
          case 4:
            this.form.detailTextField.retailer = new MDCTextField(mdc);
            break;
          default:
            this.form.subjectTextField = new MDCTextField(mdc);
            break;
        }
      });
    },
  },
};
</script>

<style scoped >
.post-img {
  padding: 5px;
  cursor: pointer;
  width: 100px;
  height: 100px;
}
.post-img-wrapper {
  width: 100px;
}

.post-img-wrapper img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.remove-image-new {
  top: -16px;
  right: -16px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background: #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid #fff;
  color: #fff;
  line-height: 0px;
}
.post-img {
  width: 100px;
  display: inline-block;
}
.post-img img {
  width: 100px;
}

.d-none {
  display: none;
}
.tag-ul {
  position: relative;
  z-index: 1;
  margin-left: 20px;
  width: 100%;
}
.tag-ul li {
  background-color: #c8c8c8;
  padding: 10px;
  border-bottom-color: #000;
}

.p-5 {
  padding: 5px !important;
}

.mr-10 {
  margin-right: 10px !important;
}

.cursor-pointer {
  cursor: pointer;
}
.no-border {
  border: none;
}
/* reset */
.sm_star * {
  margin: 0;
  padding: 0;
  font-family: "Roboto", Arial, dotum, sans-serif;
  font-weight: normal;
  font-size: 13px;
  color: #222;
}
ol,
ul,
li {
  list-style: none;
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
}
th {
  font-weight: normal;
}
form,
fieldset,
iframe {
  display: block;
  border: 0;
}
img,
button {
  border: none;
  vertical-align: middle;
}
hr {
  height: 0;
  display: none;
}
i,
em,
address {
  font-style: normal;
}
label,
button {
  cursor: pointer;
}
blockquote,
q {
  quotes: none;
}
caption,
.hide {
  visibility: hidden;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -9999em;
}
legend {
  overflow: hidden;
  visibility: hidden;
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -100%;
  white-space: nowrap;
  z-index: -1;
}
input[type="text"],
input[type="password"],
input[type="email"],
input[type="search"],
input[type="image"],
input[type="tel"],
textarea {
  -webkit-appearance: none;
  -webkit-border-radius: 0;
}
input:focus {
  outline: none;
}
::-webkit-input-placeholder {
  color: #999;
}
::-moz-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}
::-webkit-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}
a {
  color: #222;
  text-decoration: none;
}
a:link,
a:visited {
  text-decoration: none;
}
button {
  display: inline-block;
  background: none;
  border: none;
  outline: none;
}
::selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}

/* header */
.sm_star {
  position: relative;
  margin: 0 auto;
}
.sm_star.backBg:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 997;
}
.sm_header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 56px;
  border-bottom: 1px solid #e9e9e9;
  z-index: 999;
  background-color: #fff;
  box-shadow: none;
}
.sm_header h1 {
  text-align: center;
  color: #212121;
  font-size: 1.25rem;
  line-height: 2rem;
  font-weight: 500;
  padding-top: 12px;
}
.sm_header .menu_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
}
.sm_header .menu_btn span {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  font-size: 0;
  display: inline-block;
}
.sm_header .menu_btn:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: -5px;
}
.sm_header .menu_btn:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: 5px;
}
.sm_header .search_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/search_btn.svg") center center no-repeat;
  background-size: 22px auto;
}
.sm_header .search_btn span {
  font-size: 0;
  text-indent: -9999px;
}
.sm_header .back_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/back_btn.png") center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}
.sm_header .more_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/more_btn.png") center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}
.sm_header .more_box {
  position: absolute;
  right: 15px;
  top: 45px;
  width: 80px;
  z-index: 10;
}
.sm_header .close_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/close_btn.svg") center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}
.more_box {
  display: inline-block;
  padding: 15px 20px;
  background: #fff;
  box-shadow: 0 10px 13px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(206, 218, 220, 0.5);

  display: none;
}
.more_box a {
  display: block;
  color: #333;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: left;
  margin-bottom: 5px;
}
.more_box a:nth-last-child(1) {
  margin-bottom: 0;
}

.sm_header .upload_btn {
  width: 80px;
  height: 55px;
  line-height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  font-size: 15px;
  color: #2d6dcc;
}
.sm_header .upload_btn span {
  font-size: 15px;
  color: #2d6dcc;
  font-weight: 500;
}

.search_box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 10;
  display: none;
}
.search_box .search_close {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/close_btn.svg") center center no-repeat;
  background-size: 22px auto;
  text-indent: -9999px;
}
.search_box .search_form {
  position: absolute;
  left: 60px;
  top: 12px;
  border: 0;
  background: #fff;
  font-size: 18px;
  color: #212121;
  height: 30px;
  width: calc(100% - 125px);
}

/* layer img */
.layer_img {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 999;
  overflow-x: hidden;
  overflow-y: auto;
  display: none;
}
.layer_img .layer_close {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  z-index: 999;
}
.layer_img .layer_close:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  display: inline-block;
  content: "";
  position: absolute;
  transform: rotate(-45deg);
  margin-top: -2px;
  top: 50%;
  left: 50%;
  margin-left: -9px;
}
.layer_img .layer_close:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  display: inline-block;
  content: "";
  position: absolute;
  transform: rotate(45deg);
  margin-top: -2px;
  top: 50%;
  left: 50%;
  margin-left: -9px;
}
.layer_img .img_placer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  white-space: nowrap;
  width: 100%;
}
.layer_img .img {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  text-align: center;
  white-space: normal;
  position: relative;
}
.layer_img .img_placer:after {
  display: inline-block;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  content: "";
}
.layer_img .img img {
  display: inline;
  max-width: 100%;
}

/* layer pop */
.layer_pop {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 999;
  display: none;
}
.layer_con {
  width: 90%;
  max-width: 300px;
  background: #fff;
  box-sizing: border-box;
  padding: 25px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 19px 38px 0 rgba(0, 0, 0, 0.26);
}
.layer_con .layer_txt {
  font-size: 16px;
  color: #818181;
  line-height: 1.5;
}
.layer_con .layer_btn {
  position: relative;
  padding: 30px 0 0 0;
  text-align: right;
}
.layer_con .layer_btn a {
  display: inline-block;
  padding: 5px 15px;
  color: #2d6dcc;
  font-weight: 500;
  font-size: 14px;
  margin-left: 10px;
}

/* upload */
.upload_wrap {
  position: relative;
  padding: 15px;
}
.upload_list {
  position: relative;
  font-size: 0;
}
.upload_list > li {
  display: inline-block;
  vertical-align: top;
  width: 32%;
  margin-right: 2%;
  margin-bottom: 2%;
}
.upload_list > li:nth-child(3n) {
  margin-right: 0;
}
.upload_list .file {
  position: relative;
  height: 0;
  padding-top: 100%;
}
.upload_list .file > a {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.upload_list .file img,
.upload_list .file video,
.upload_list .file iframe {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.upload_list .file.active a:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(49, 61, 75, 0.3);
}
.upload_list .file .pic {
  display: inline-block;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  color: #fff;
  background: #2d6dcc;
  font-size: 13px;
  position: absolute;
  right: 10px;
  top: 10px;
  border-radius: 50%;
  z-index: 10;
}

/* user */
.user_box {
  position: relative;
}
.user_box .user_img {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  margin-right: 15px;
}
.user_box .user_img img {
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.user_box .user_txt {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.user_box .user_txt .name {
  font-size: 14px;
  color: #212121;
}
.user_box .user_txt .date {
  position: relative;
  padding: 2px 0 0 0;
  color: #818181;
  font-size: 14px;
}
.user_box .user_write {
  position: absolute;
  right: 0;
  top: 0;
}
.user_box .user_write > a {
  display: inline-block;
  vertical-align: top;
  margin-left: 15px;
  background-size: 24px auto !important;
}
.user_box .user_write .write_btn {
  font-size: 12px;
  color: #acb4be;
  padding-top: 28px;
  background: url("/images/write_icon.png") center top no-repeat;
}
.user_box .user_write .write_btn.me {
  background: url("/images/my_write_icon.png") center top no-repeat;
}
.user_box .user_date {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 12px;
  color: #818181;
}
.user_fixed {
  position: fixed;
  left: 0;
  top: 55px;
  width: 100%;
  height: 75px;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding: 15px;
  z-index: 10;
}

/* style */
.sm_wrap {
  position: relative;
  padding: 55px 0 0 0;
  height: 100vh;
}
.sm_list {
  position: relative;
}
.sm_list.view {
  /* padding-bottom: 85px; */
}
.sm_list.learning {
  padding: 90px 15px 15px 15px;
  background: #f9f9f9;
  position: relative;
}
.sm_list_box {
  position: relative;
}
.sm_list_box > .list_box {
  position: relative;
  margin-bottom: 15px;
}
.sm_list_box > .list_box:nth-last-child(1) {
  margin-bottom: 0;
}
.sm_list .no_data {
  position: relative;
  height: calc(100vh - 210px);
  text-align: center;
  padding: 50px 0 0 0;
  min-height: 300px;
}
.sm_list .no_data .no_img img {
  max-width: 120px;
}
.sm_list .no_data p:nth-child(2) {
  position: relative;
  padding: 20px 0 0 0;
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}
.sm_list .no_data p:nth-child(3) {
  position: relative;
  padding: 15px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #818181;
  line-height: 1.57;
}
.sm_list.view .list_box {
  margin-bottom: 0;
}

.list_box {
  position: relative;

  background: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  padding: 15px;
}
.list_box .user_con {
  padding: 15px 0 0 0;
}
.list_box .user_tag {
  padding: 10px 0 0 0;
}
.list_box .user_opt {
  margin: 20px 0 0 0;
}
.list_box .user_imgList {
  margin: 20px 0 0 0;
}
.user_con {
  position: relative;
  font-size: 14px;
  color: #818181;
  line-height: 1.57;
}
.user_con .em {
  color: #212121;
  margin-right: 5px;
  font-size: 14px;
}
.user_tag {
  position: relative;
  font-size: 0;
}
.user_tag span {
  display: inline-block;
  vertical-align: top;
  margin-right: 5px;
  font-size: 12px;
  color: #313d4b;
  padding: 2px 3px;
  background: #f4f5f6;
  border-radius: 2px;
}
.user_opt {
  position: relative;
  font-size: 12px;
  color: #818181;
}
.user_opt .right {
  position: absolute;
  right: 0;
  top: 0;
  color: #818181;
}
.list_btn {
  position: relative;
  text-align: center;
  font-size: 0;
  border-top: 1px solid #e6eced;
  margin: 15px 0 0 0;
  padding: 10px 0 0 0;
}
.list_btn a {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 10px 0 25px;
  background-size: 17px auto;
  background-position: left center;
  background-repeat: no-repeat;
  margin: 0 5px;
  color: #acb4be;
}
.list_btn a.like {
  background-image: url("/images/like_btn.png");
}
.list_btn a.like.on {
  background-image: url("/images/like_btn_on.png");
}
.list_btn a.reply {
  background-image: url("/images/reply_btn.png");
}
.list_btn a.share {
  background-image: url("/images/share_btn.png");
}
.user_imgList {
  position: relative;
  font-size: 0;
}
.user_imgList a {
  display: inline-block;
  position: relative;
}
.user_imgList a img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}
.user_imgList a.more:before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  z-index: 1;
}
.user_imgList a.more span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 18px;
  z-index: 2;
}
.user_imgList > a:nth-child(1) {
  width: 66%;
  height: 0;
  padding-top: 66%;
}
.user_imgList > a:nth-child(2) {
  width: 32%;
  height: 0;
  padding-top: 32%;
  position: absolute;
  right: 0;
  top: 0;
}
.user_imgList > a:nth-child(3) {
  width: 32%;
  height: 0;
  padding-top: 32%;
  position: absolute;
  right: 0;
  bottom: 0;
}
.user_imgList.view a {
  display: block;
  padding-top: 0;
  height: auto;
  position: relative;
  right: auto;
  top: auto;
  width: auto;
  margin-bottom: 10px;
}
.user_imgList.view a img {
  position: relative;
  left: 0;
  top: auto;
  width: auto;
  max-width: 100%;
  height: auto;
  transform: none;
}
.user_imgList.reply {
  margin: 0 0 0 55px;
  white-space: nowrap;
  overflow-x: auto;
}
.user_imgList.reply a {
  display: inline-block;
  width: 100px;
  height: 100px;
  padding-top: 0;
  position: relative;
  left: auto;
  top: auto;
  margin-right: 10px;
}
.input_file .user_imgList {
  white-space: nowrap;
  overflow-x: auto;
}
.input_file .user_imgList a {
  display: inline-block;
  width: 100px;
  height: 100px;
  padding-top: 0;
  position: relative;
  left: auto;
  top: auto;
  margin-right: 10px;
}
.user_imgList a.video:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background: rgba(49, 61, 75, 0.3);
  position: absolute;
  left: 0;
  top: 0;
}
.user_imgList a.video:before {
  content: "";
  display: inline-block;
  width: 25px;
  height: 25px;
  background: url("/images/play_icon.png") center center no-repeat;
  background-size: 25px auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.reply_wrap {
  position: relative;
  background: #f9f9f9;
  padding: 15px;
}
.reply_wrap > div:nth-last-child(1) {
  margin-bottom: 0;
}
.reply_box {
  position: relative;
  margin-bottom: 15px;
}
.reply_box .user_box .user_date {
  right: 40px;
  color: #a6a6a6;
}
.reply_box .user_box .more_btn {
  width: 22px;
  height: 22px;
  background: url("/images/reply_more_btn.png") center center no-repeat;
  background-size: 22px auto;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-indent: -9999px;
}
.reply_box .user_con {
  padding: 10px 15px 10px 58px;
}
.reply_box .list_btn {
  text-align: left;
  border-top: 0;
  margin: 0;
  padding: 0 0 0 55px;
}
.reply_box > .reply_box {
  padding: 10px 0 0 50px;
}

.comment_box {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 50;
  /* padding: 15px 15px 20px 15px; */
  background: #fff;
  box-sizing: border-box;
  border-top: 1px solid #e6eced;
}
.comment_area {
  position: relative;
  display: flex;
  align-items: center;
  padding: 16px;
}
.comment_area button {
  display: inline-block;
  width: 50px;
  height: 50px;
  text-indent: -9999px;
  font-size: 0;
  position: absolute;
  top: 0;
  vertical-align: top;
}
.comment_area .picture_btn {
  font-size: 22px;
  color: #acb4be;
  position: relative;
  margin-right: 24px;
}
.comment_area .video_btn {
  background: url("/images/video_btn.png") center center no-repeat;
  background-size: 22px auto;
  position: relative;
}
.comment_area .comment_btn {
  background: url("/images/comment_btn.png") center center no-repeat;
  background-size: 22px auto;
  right: 0;
}
.comment_area .comment_btn.on {
  background: url("/images/comment_btn_on.png") center center no-repeat;
  background-size: 22px auto;
}
.comment_textarea {
  position: relative;
  vertical-align: top;
  font-size: 14px;
  background: none;
  border: 0;
  width: calc(100% - 130px);
  resize: none;
  outline: none;
  height: 25px;
  margin-top: 14px;
}
.comment_area .tail_txt {
  position: absolute;
  right: 0;
  top: 15px;
  font-size: 14px;
  color: #acb4be;
}

.search_list {
  position: relative;
  background: #f9f9f9;
  padding: 15px;
  min-height: calc(100vh - 85px);
}
.search_list .no_data {
  position: relative;
  text-align: center;
  padding: 30px 0 0 0;
  min-height: 300px;
}
.search_list .no_data p:nth-child(1) {
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}
.search_list .no_data p:nth-child(2) {
  position: relative;
  padding: 15px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #818181;
  line-height: 1.57;
}

.write_wrap {
  position: relative;
  padding-bottom: 55px;
}
.write_tag {
  position: relative;
  padding: 15px;
  background: #fff;
  border-bottom: 1px solid #e6eced;
}
.write_tag .tag_tail {
  position: relative;
  padding: 10px 15px 0 15px;
  font-size: 12px;
  color: #acb4be;
}
.write_tag .tag_form {
  position: relative;
  padding: 15px;

  border: 1px solid rgba(172, 180, 190, 0.7);
  min-height: 20px;
}
.write_tag .tag_form .tag_btn {
  width: 25px;
  height: 25px;
  font-size: 0;
  text-indent: -9999px;
  background: url("/images/addTag_icon.png") center center no-repeat;
  background-size: 22px auto;
  vertical-align: middle;
  margin-right: 5px;
}
.write_tag .tag_form span.txt {
  font-size: 14px;
  color: #acb4be;
  vertical-align: middle;
  line-height: 1;
}
.write_tag .tag_form span.tag {
  display: inline-block;
  padding: 3px 5px;
  background: #f0f1f2;
  font-size: 14px;
  color: #313d4b;
  vertical-align: middle;
  margin-right: 3px;
  line-height: 1.4;
}
.write_tag .tag_form span.tag.txt {
  color: #313d4b;
  line-height: 1.4;
  background: none;
}
.write_form {
  position: relative;
  padding: 16px;
  background: #fff;
}
.write_form textarea {
  border: 0;
  background: none;
  font-size: 14px;
  color: #313d4b;
  line-height: 1.57;
  width: 100%;
  box-sizing: border-box;
  min-height: 300px;
  resize: none;
  outline: none;
}

.tag_list {
  position: relative;
}
.tag_list ul {
  position: relative;
}
.tag_list ul li {
  position: relative;
  display: block;
  background: #f9f9f9;
  border-bottom: 1px solid #e6eced;
}
.tag_list ul li span {
  display: block;
  padding: 15px;
}

.input_file {
  position: fixed;
  left: 0;
  bottom: 85px;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  z-index: 10;
  background: #fff;
}
.input_file + .write_form textarea {
  min-height: inherit;
  height: calc(100vh - 410px);
}

.edit_wrap {
  position: relative;
  height: calc(100vh - 55px);
  text-align: center;
  overflow-x: hidden;
  overflow-y: auto;
}
.edit_wrap .placer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  white-space: nowrap;
  width: 100%;
}
.edit_wrap .placer:after {
  display: inline-block;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  content: "";
}
.edit_wrap .edit_file {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  text-align: center;
  white-space: normal;
  position: relative;
}
.edit_wrap .edit_file img {
  display: inline;
  max-width: 100%;
}
.edit_wrap .edit_file .video {
  display: inline-block;
  position: relative;
}
.edit_wrap .edit_file .video:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background: rgba(49, 61, 75, 0.3);
  position: absolute;
  left: 0;
  top: 0;
}
.edit_wrap .edit_file .video:before {
  content: "";
  display: inline-block;
  width: 50px;
  height: 50px;
  background: url("/images/play_icon.png") center center no-repeat;
  background-size: 50px auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.t-color-helper {
  color: #acb4be;
}
.mdc-icon-custom {
  font-size: 22px !important;
}
.mdc-notched-outline--upgraded {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.mdc-notched-outline__notch {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 85%;
}
.valid-error {
  color: #fc5356 !important;
}
.valid-error-line {
  border: 1px solid red;
}
.write_form__attachment {
  /* padding-bottom: 85px !important; */
}

.mdc-select__dropdown-icon {
  color: #c3cdce;
}

.mdc-select:not(.mdc-select--disabled) .mdc-select__native-control,
.mdc-select:not(.mdc-select--disabled) .mdc-select__selected-text {
  color: rgba(0, 0, 0, 0.6);
}

.editor-label {
  margin-top: 4px;
  color: #acb4be;
}
.label-warning {
  color: #fc5356 !important;
}
.attachment-wrapper {
  display: flex;
}
.mdc-notched-outline__notch {
  /* Ignore the width set by script, and change it to be calculated from the width of `mdc-floating-label` by setting `auto`. */
  width: auto !important;
}

.mdc-notched-outline__notch > label.mdc-floating-label--float-above {
  transform: translateY(-130%);
  font-size: calc(1rem * 0.75);
  top: calc(17px * (1 - ((1 - 0.75) / 2)));
}
</style>
